import { ComponentProps, useMemo } from "react";
import { StyledPrice } from "./Price.styles";
import { usePrice } from "~/hooks/usePrice";

export interface PriceProps extends ComponentProps<typeof StyledPrice> {
  amount?: number | string;
  currencyCode: string;
  hasCurrencyCode?: boolean;
}

const Price = ({
  amount = "0",
  currencyCode,
  hasCurrencyCode = true,
  ...props
}: PriceProps) => {
  const { formatPrice } = usePrice();

  const formattedAmount = useMemo(
    () => formatPrice(amount),
    [amount, formatPrice]
  );

  return (
    <StyledPrice {...props}>
      {hasCurrencyCode ? currencyCode : ""} {formattedAmount}
    </StyledPrice>
  );
};

export default Price;
